/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Dark_Duck_PantInputs */

const en_shy_dark_duck_pant = /** @type {(inputs: Shy_Dark_Duck_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulling data`)
};

const de_shy_dark_duck_pant = /** @type {(inputs: Shy_Dark_Duck_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten werden abgerufen`)
};

/**
* | output |
* | --- |
* | "Pulling data" |
*
* @param {Shy_Dark_Duck_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_dark_duck_pant = /** @type {((inputs?: Shy_Dark_Duck_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Dark_Duck_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_dark_duck_pant(inputs)
	return de_shy_dark_duck_pant(inputs)
});